import { LabelEditorUtils } from '@project/components/label/label-editor/label-editor-utils';
import { StringUtils } from './string-utils';
import { SimpleTextValueVO, TableTextValueVO, TextureAreaUsageVO, TextValueVO } from '@shared/vo/meta-element.vo';

export class TextureAreaUsageUtils {
  public static mergedTextureAreaUsagesFilter(textureAreaUsage: TextureAreaUsageVO): boolean {
    return !!(textureAreaUsage.previousMergedUsageId || textureAreaUsage.nextMergedUsageId);
  }

  public static mergedTextureAreaUsages(textureAreaUsages: TextureAreaUsageVO[]): TextureAreaUsageVO[][] {
    const mergedTextureAreaUsages: TextureAreaUsageVO[][] = [];
    const startUsages = textureAreaUsages.filter(textureAreaUsage => !textureAreaUsage.previousMergedUsageId);

    for (const startUsage of startUsages) {
      const mergedTextureAreaUsage: TextureAreaUsageVO[] = [];
      let currentUsage: TextureAreaUsageVO | undefined = startUsage;
      while (currentUsage) {
        mergedTextureAreaUsage.push(currentUsage);
        currentUsage = textureAreaUsages.find(textureAreaUsage => textureAreaUsage.identity.equals(currentUsage?.nextMergedUsageId));
      }
      mergedTextureAreaUsages.push(mergedTextureAreaUsage);
    }

    return mergedTextureAreaUsages;
  }

  public static isEmptyTextValue(textValue: TextValueVO): boolean {
    if (!textValue) return true;

    switch (textValue.type) {
      case 'SimpleTextValueVO':
      case 'CompressionSimpleTextValueVO':
        const simpleTextValueVO: SimpleTextValueVO = <SimpleTextValueVO>textValue;
        const text = simpleTextValueVO.text ?? '';
        // Note: isHTML5Data() requites 'toLowerCase' to work correctly.
        const plainText: string = LabelEditorUtils.isHTML5Data(text.toLowerCase())
          ? LabelEditorUtils.extractTextFromHTML5Data(text)
          : text;
        return StringUtils.isEmpty(plainText);

      case 'TableTextValueVO':
        const tableTextValueVO: TableTextValueVO = <TableTextValueVO>textValue;
        const rows = tableTextValueVO.rows ?? [];
        return rows.flatMap(row => row.items)
          .every(item => this.isEmptyTextValue(item.value));

      default:
        return false;
    }
  }
}
